const META_PIXEL_ID = "1097918726148852";
const CONSENT_KEY = "bidit.cookieConsent";

function hasMarketingConsent() {
  try {
    return JSON.parse(localStorage.getItem(CONSENT_KEY) || "null")?.marketing === true;
  } catch (_) {
    return false;
  }
}

export function initMetaPixel() {
  if (typeof window === "undefined" || !hasMarketingConsent()) return false;
  if (window.fbq) return true;

  const fbq = function () {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);

  fbq("init", META_PIXEL_ID);
  return true;
}

export function trackMetaPageView() {
  if (!initMetaPixel()) return;
  window.fbq("track", "PageView");
}

export function trackProfessionalRegistration() {
  if (!initMetaPixel()) return;
  window.fbq("track", "CompleteRegistration", {
    content_name: "professional_registration",
    status: true,
  });
}
